import tokens from '@kluein/design-tokens';
import { Box, type RoundType, Skeleton, Text } from '@kluein/klue-ui';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

type RivalGroupActionItemProps = {
  href: string;
  label: string;
  isLoading: boolean;
  count: number;
  separator?: boolean;
  round?: RoundType;
  active?: boolean;
  disabled?: boolean;
};

const StyledBox = styled(Box)`
  ${({ theme }) => css`
    > a {
      width: 100%;
      text-align: center;
    }

    &.active,
    &:hover {
      background-color: ${tokens.color.primaryintel.light};
      > a {
        color: ${tokens.color.primaryintel.main};
      }
    }
  `}
`;

export function RivalGroupActionItem(props: RivalGroupActionItemProps) {
  const {
    href,
    label,
    count,
    separator = false,
    isLoading,
    round,
    active,
    disabled,
    ...args
  } = props;
  const [zIndex, setIndex] = useState<number | undefined>(undefined);

  const content = (
    <Box
      pad={{
        vertical: 'medium',
      }}
    >
      {isLoading ? (
        <Box width="small" margin="auto">
          <Skeleton.Line numberOfLines={1} />
        </Box>
      ) : (
        <Text
          size="small"
          fontWeight="semibold"
          color={disabled ? tokens.color.status.disabled.dark : undefined}
        >
          {label}
        </Text>
      )}
    </Box>
  );

  return (
    <StyledBox
      align="center"
      flex="grow"
      justify="center"
      direction="row"
      gap="small"
      background={tokens.color.neutral.white.main}
      width="50%"
      className={active ? 'active' : ''}
      round={round}
      border={
        separator
          ? {
              side: 'left',
              size: 'xsmall',
              color: tokens.color.neutral.lightgrey.main,
            }
          : undefined
      }
      style={disabled ? { pointerEvents: 'none' } : undefined}
    >
      {disabled ? (
        <Box {...args}>{content}</Box>
      ) : (
        <Link
          {...args}
          to={href}
          onFocus={() => setIndex(100)}
          onBlur={() => setIndex(undefined)}
          style={{
            textDecoration: 'none',
            paddingBottom: 'medium',
            paddingTop: 'medium',
            zIndex,
          }}
        >
          {content}
        </Link>
      )}
    </StyledBox>
  );
}
